import { useEffect, useState, useCallback } from 'react';
import { ADMIN_TYPES } from '../../constans/parameter';
import { Box, Button, Card, CardActions, CardContent, TextField } from '@mui/material';
import useApiService from '../../component/hooks/useApiService';
import Select from '../../component/ui/select/select';
import { useAppSnackbar } from '../../component/providers/SnackbarProvider';

import { apiUrls } from '../../constans/apiUrls';
import stringFormat from '../../component/common/stringFormat';

const AddAdmin = ({ data, close, adminPanelAction, openType }) => {


    const { executePost, executeDelete, executePut, executePatch } = useApiService();
    const [dataModel, setDataModel] = useState({});
    const [adminTypes] = useState(ADMIN_TYPES);
    const [viewMode, setViewMode] = useState(false);
    const { showSnackbar } = useAppSnackbar();

    const setField = (fields) => {
        setDataModel(oldState => ({ ...oldState, ...fields }));
    };

    useEffect(() => {
        checkViewMode();
        if (data) { getDataByGrid(); }
    }, []);

    const checkViewMode = () => {
        if (openType == "View" || openType == "Delete") {
            setViewMode(true);
        }
    }

    const getDataByGrid = () => {
        if (data) {
            setField(data);

        }
    }

    const requiredValidation = () => {
        const requiredFields = [
            { key: 'email', label: "Email" },
            { key: 'password', label: "Şifre" },
            { key: 'ConfirmPassword', label: "Şifre Tekrar" },
            { key: 'role', label: "Rol" },
        ];

        for (let field of requiredFields) {
            if (!dataModel[field.key]) {
                showSnackbar(`${field.label} zorunludur.`, 'error');
                return false;
            }
        }

        if (!isValidEmail(dataModel.email)) {
            showSnackbar('Email formatı geçersiz.', 'error');
            return false;
        }

        if (dataModel.password !== dataModel.ConfirmPassword) {
            showSnackbar('Şifreler eşleşmiyor', 'error');
            return false;
        }
        if ((dataModel.password || '').length < 6) {
            showSnackbar('Şifre minimum 6 karakterli olmalı.', 'error');
            return false;
        }

        return true;
    };


    const isValidEmail = (email) => {
        const s = String(email || '').trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
    };

    const createNewAdmin = async () => {
        if (!requiredValidation()) {
            return;
        }

        try {
            const postAdminData = { ...dataModel };
            delete postAdminData.confirmPassword;

            const res = await executePost({
                url: apiUrls.Admin,
                data: postAdminData,
            });

            if (res.admin) {
                close && close(res);
            } else {
                showSnackbar('Admin oluşturulamadı.', 'error');
                close(false);
            }
        } catch (err) {
            showSnackbar('Admin oluşturulamadı. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    function formatString(input) {
        let formattedString = input.replace(/\s*\+\s*/g, '\n');
        const maxLineLength = 35;
        const lines = formattedString.split('\n');
        const result = lines.map(line => {
            if (line.length > maxLineLength) {
                const parts = [];
                while (line.length > maxLineLength) {
                    const part = line.slice(0, maxLineLength);
                    parts.push(part.trim());
                    line = line.slice(maxLineLength);
                }
                parts.push(line.trim());
                return parts.join('\n');
            }
            return line;
        });
        return result.join('\n');
    }

    const handleChange = (e, fieldName) => {
        const inputText = formatString(e);
        setField({ [fieldName]: inputText });
    };

    const DeleteAdmin = async () => {
        try {
            await executeDelete({
                url: stringFormat(apiUrls.AdminDelete, dataModel?.id),
                data: dataModel?.id,
            });
            close(true);
        } catch (err) {
            showSnackbar('Admin silinemedi. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    const updateAdminDetail = async () => {
        try {
            await executePatch({
                url: stringFormat(apiUrls.AdminUpdate, dataModel?.id),
                data: dataModel,
            });
            close(true);
        } catch (err) {
            showSnackbar('Admin bilgileri güncellenemedi. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    const updateAdminPassword = async () => {
        try {
            await executePut({
                url: stringFormat(apiUrls.AdminPasswordUpdate, dataModel?.id),
                data: { password: dataModel.password },
            });
            close(true);
        } catch (err) {
            showSnackbar('Şifre güncellenemedi. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }

    }

    const filteredActionList = () => {
        switch (openType) {
            case "New":
                return actionList.filter(action => action.name === 'Save' || /* action.name === 'Documents' || */ action.name === 'Cancel');
            case "View":
                return actionList.filter(action => /* action.name === 'Documents' || */ action.name === 'Cancel');
            case "Update":
                return actionList.filter(action => action.name === 'Cancel' || action.name === adminPanelAction?.name);
            case "PasswordUpdate":
                return actionList.filter(action => action.name === 'Cancel' || action.name === adminPanelAction?.name);
            case "Delete":
                return actionList.filter(action => action.name === 'Cancel' || action.name === adminPanelAction?.name);
            default:
                return actionList.filter(action => action.name === 'Save' ||  /* action.name === 'Documents' || */  action.name === 'Cancel');
        }
    }
    const actionList = [
        {
            name: 'Save',
            label: 'Kaydet',
            order: 3
        },
        {
            name: 'Update',
            label: "Güncelle",
            order: 3
        },

        { name: 'Cancel', variant: 'text', label: "Vazgeç", order: 0 },
        ...getadminPanelAction()

    ]

    function getadminPanelAction() {
        return adminPanelAction ? [
            {
                name: adminPanelAction.name,
                label: adminPanelAction.label,
                order: 3
            }
        ] : [];
    }
    const onActionClick = useCallback((action) => {
        if (action.name === 'Save') {
            createNewAdmin();
        }
        else if (action.name === 'DeleteAdmin') {
            DeleteAdmin();
        }
        else if (action.name === 'ChangeRequest') {
            updateAdminDetail();
        }
        else if (action.name === 'ChangePassword') {
            updateAdminPassword();
        }
        else if (action.name == 'Cancel') {
            close && close();
        }
    }, [dataModel]);

    return (
        <Card sx={{ display: 'flex', flexDirection: 'column', height: 'auto' }}>
            <Box sx={{ flex: 1, overflow: 'auto', }}>
                <CardContent
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(1fr, 1fr))',
                        gap: 2,
                    }}
                >
                    {/* 1. Email */}
                    <TextField
                        name="Email"
                        label="Email"
                        fullWidth
                        required
                        type="email"
                        slotProps={{ input: { readOnly: viewMode || openType === "PasswordUpdate" } }}
                        value={dataModel?.email || ''}
                        onBlur={(e) => {
                            const value = e.target.value.trim();
                            setField({ email: value });
                            if (value && !isValidEmail(value)) {
                                showSnackbar('Email formatı geçersiz.', 'error');
                            }
                        }}
                        onChange={(e) => setField({ email: e.target.value })}
                    />

                    {/* 2. Rol */}
                    {openType !== "PasswordUpdate" && (
                        <Select
                            name="BeneficiaryCountyCode"
                            label="Rol"
                            datasource={adminTypes}
                            columns={["ValueText1"]}
                            required
                            valuePath="Code"
                            readOnly={viewMode}
                            value={dataModel?.role}
                            onChange={(value) => setField({ role: value })}
                        />
                    )}

                    {/* 3-4. Şifre alanları (Create/PasswordUpdate) */}
                    {openType !== "Update" && (openType === "Create" || openType === "PasswordUpdate") && (
                        <TextField
                            required
                            name="Password"
                            label="Şifre"
                            type="password"
                            fullWidth
                            slotProps={{
                                input: { readOnly: viewMode },
                            }}
                            value={
                                (openType !== "Create" && openType !== "PasswordUpdate")
                                    ? dataModel?.PasswordHash || ''
                                    : dataModel?.password || ''
                            }
                            onChange={(e) => setField({ password: e.target.value })}
                        />
                    )}

                    {openType !== "Update" && (openType === "Create" || openType === "PasswordUpdate") && (
                        <TextField
                            required
                            name="ConfirmPassword"
                            label="Şifre Tekrar"
                            type="password"
                            fullWidth
                            value={dataModel?.ConfirmPassword || ''}
                            onChange={(e) => setField({ ConfirmPassword: e.target.value })}
                        />
                    )}
                </CardContent>

            </Box>
            <CardActions
                sx={{
                    justifyContent: 'flex-end',
                    borderTop: '1px solid #e0e0e0',
                    p: 2,
                    backgroundColor: '#fff',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1,
                }}
            >

                {filteredActionList()
                    .sort((a, b) => a.order - b.order)
                    .map((action) => (
                        <Button
                            key={action.name}
                            variant={action.variant || 'contained'}
                            onClick={() => onActionClick(action)}
                            sx={{

                                ...(action.variant && {
                                    textTransform: 'none',
                                    color: '#1976d2',
                                    border: 'none',
                                    fontWeight: '500',
                                    '&:hover': {
                                        backgroundColor: '#e3f2fd'
                                    }
                                }),

                                ...(!action.variant && {
                                    textTransform: 'none',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontWeight: 'bold'
                                })
                            }}
                        >
                            {action.label}
                        </Button>
                    ))}
            </CardActions>
        </Card>
    );
};

export default AddAdmin;
